<template>
	<div>

		<parking-admin v-if="MIX_getCurrentUser().userType === 'Staff'"/>

		<parking-steward v-if="MIX_getCurrentUser().userType === 'Steward'"/>

	</div>
</template>

<script>

import ParkingAdmin from "@/views/parking/admin/ParkingAdmin.vue";
import ParkingSteward from "@/views/parking/steward/ParkingSteward.vue";

export default {

	name: "Parking",

	components: {ParkingSteward, ParkingAdmin},

	data: () => ({}),

	methods: {},

}
</script>

<style scoped>

</style>
